import React, { useState, useEffect, useRef } from 'react';
import {
  ArrowRight, Shield, Zap, CreditCard, Smartphone, Clock, CheckCircle, Users,
  TrendingUp, Wifi, Lock, Star, Mail, Phone, User, Share2, Twitter, Facebook, Instagram,
  Target, Eye, Heart, ChevronLeft, ChevronRight, Play, Pause, Camera, Calendar,
  MapPin, Coffee, Trophy, Music, Gamepad2, Palette, X, ZoomIn, Crown, Rocket
} from 'lucide-react';
import CompanyLogosMarquee from "./companies";
import Header from "./header";
import Footer from "./footer";
const Aboutus = () => {
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(0);
  const [employeesData, setEmployeesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);

  // Carousel states
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Image slider popup states
  const [isImageSliderOpen, setIsImageSliderOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isImageTransitioning, setIsImageTransitioning] = useState(false);

  // Fun activities data
  const funActivities = [
    {
      id: 1,
      title: "Sports Meet",
      description: "Our team participated in a thrilling sports meet over the year.",
      image: "./photos/67550.jpg",
      category: "Sports",
      // date: "February 2025",
      location: "Mumbai Sports Complex",
      icon: <Trophy className="w-5 h-5" />
    },
    {
      id: 3,
      title: "Water Sports Outing",
      description: "A fun-filled day at the water park with thrilling rides and team bonding",
      image: "./photos/IMG-20220829-WA0044.jpg",
      category: "Creative",
      // date: "August 2022",
      location: "Water Sports, Mumbai",
      icon: <Palette className="w-5 h-5" />
    },
    {
      id: 4,
      title: "Adventure Trip",
      description: "Exploring the ancient rock-cut temples and enjoying a day of cultural enrichment",
      image: "./photos/IMG-20221223-WA0003.jpg",
      category: "Social",
      // date: "December 2021",
      location: "Elephanta Island",
      icon: <Coffee className="w-5 h-5" />
    },
    {
      id: 5,
      title: "Team Building Adventure",
      description: "A thrilling trek in the Matheran Hills to strengthen team bonds and enjoy nature",
      image: "./photos/67551.jpg",
      category: "Team Building",
      // date: "August 2021",
      location: "Matheran Hills",
      icon: <Users className="w-5 h-5" />
    }
  ];

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % 4);
    }, 3000);

    // Simulate fetching employee data
    fetchEmployeesData();

    return () => clearInterval(interval);
  }, []);

  // Auto-play carousel
  useEffect(() => {
    if (isAutoPlaying && !isTransitioning) {
      const interval = setInterval(() => {
        nextSlide();
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [currentSlide, isAutoPlaying, isTransitioning]);

  // Handle escape key for closing image slider
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isImageSliderOpen) {
        closeImageSlider();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isImageSliderOpen]);
  const teamData = {
    leader: {
      Id: 1,
      OfficerName: "Umesh Chandra",
      OfficerDesignation: "CEO & Founder",
      Email: "umesh@anvitechsolutions.com",
      Mobile: "+91 8828159280",
      Photo: "./photos/Founder.png",
      Bio: "Visionary leader with 15+ years of experience in fintech and payment processing innovation."
    },
    employees: [
      {
        Id: 2,
        OfficerName: "Nitesh Tiwari",
        OfficerDesignation: "Admin & Operations Head",
        Email: "nitesh@anvitechsolutions.com",
        Mobile: "+91 8425930405",
        Photo: "./photos/img_20250617.png"
      },
      {
        Id: 3,
        OfficerName: "Abhishek Singh",
        OfficerDesignation: "Lead Frontend Engineer",
        Email: "abhishek.singh@anvitechsolutions.com",
        Mobile: "+91 9939858857",
        Photo: "./photos/abhishek.jpg"
      },
      {
        Id: 4,
        OfficerName: "Adesh Tiwari",
        OfficerDesignation: "Lead Software Engineer",
        Email: "adesh@anvitechsolutions.com",
        Mobile: "+91 8080173949",
        Photo: "./photos/adesh.png"
      },
      // {
      //   Id: 5,
      //   OfficerName: "Abhishek Tiwari",
      //   OfficerDesignation: "Leading Software Specialist",
      //   Email: "abhishek.tiwari@anvitechsolutions.com",
      //   Mobile: "+91 98765 43214",
      //   Photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face"
      // },
      {
        Id: 6,
        OfficerName: "Sanidhya Tiwari",
        OfficerDesignation: "Senior Software Specialist",
        Email: "sanidhya@anvitechsolutions.com",
        Mobile: "+91 98765 43215",
        Photo: "./photos/sanidhya.png"
      },
      //   {
      //   Id: 5,
      //   OfficerName: "Mithilesh Vishwakarma",
      //   OfficerDesignation: "Senior Software Engineer",
      //   Email: "abhishek.tiwari@anvitechsolutions.com",
      //   Mobile: "+91 98765 43214",
      //   Photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face"
      // },
    ]
  };
  // Simulate the employee data fetching function
  const fetchEmployeesData = async () => {
    try {
      const mockEmployees = [
        {
          Id: 1,
          OfficerName: "Umesh Chandra",
          OfficerDesignation: "Co-Founder & Chief Executive Officer",
          Email: "umesh@anvitechsolutions.com",
          Mobile: "+91 8828159280",
          Photo: "https://media.licdn.com/dms/image/v2/C4E03AQFi2YXma_PufQ/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1516507160128?e=2147483647&v=beta&t=cxRbUOQctSzGasgSondZHgEcLE0Ue9QqgHEZ8x1G1VI"
        },
        {
          Id: 2,
          OfficerName: "Nitesh Tiwari",
          OfficerDesignation: "Admin & Operations Head",
          Email: "nitesh@anvitechsolutions.com",
          Mobile: "+91 8425930405",
          Photo: "./photos/img_20250617.png"
        },
        {
          Id: 3,
          OfficerName: "Abhishek Singh",
          OfficerDesignation: "Leading Frontend Engineer",
          Email: "abhishek.singh@anvitechsolutions.com",
          Mobile: "+91 9939858857",
          Photo: "https://media.licdn.com/dms/image/v2/D4D03AQFH9AgzYgBFZg/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1725894367578?e=1755734400&v=beta&t=A_fivEAWQx1HT5RykZSNtGSOuXtkIQb2MpagGyJaaKw"
        },
        {
          Id: 4,
          OfficerName: "Adesh Tiwari",
          OfficerDesignation: "Lead Backend Engineer",
          Email: "adesh@anvitechsolutions.com",
          Mobile: "+91 8080173949",
          Photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face"
        },
        {
          Id: 5,
          OfficerName: "Abhishek Tiwari",
          OfficerDesignation: "Leading Software Specialist",
          Email: "abhishek.tiwari@anvitechsolutions.com",
          Mobile: "+91 98765 43214",
          Photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face"
        },
        {
          Id: 6,
          OfficerName: "Sanidhya Tiwari",
          OfficerDesignation: "Senior Software Specialist",
          Email: "sanidhya@anvitechsolutions.com",
          Mobile: "+91 98765 43215",
          Photo: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop&crop=face"
        }
      ];


      setEmployeesData(mockEmployees);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching employees data:", error);
      setLoading(false);
    }
  };

  const features = [
    { icon: <Zap className="w-6 h-6" />, title: "Faster Go to Market", desc: "Accelerated development cycles that get your products to market quickly" },
    { icon: <TrendingUp className="w-6 h-6" />, title: "Scalability", desc: "Flexible architecture designed to scale seamlessly with your growth" },
    { icon: <Rocket className="w-6 h-6" />, title: "Established Accelerators & Frameworks", desc: "Empower teams with proven growth strategies" },
    { icon: <Zap className="w-6 h-6" />, title: "Value-driven Engagement", desc: "Building meaningful connections through shared value" },
    { icon: <Zap className="w-6 h-6" />, title: "Lightning Fast", desc: "Process payments in milliseconds" },
    { icon: <Smartphone className="w-6 h-6" />, title: "Omnichannel", desc: "Optimized for all devices" },
  ];


  // Calculate pagination for employees
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employeesData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(employeesData.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Carousel functions
  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev + 1) % funActivities.length);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) =>
      prev === 0 ? funActivities.length - 1 : prev - 1
    );
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const goToSlide = (index) => {
    if (isTransitioning || index === currentSlide) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const toggleAutoPlay = () => {
    setIsAutoPlaying(!isAutoPlaying);
  };

  // Image slider functions

  const openImageSlider = (index) => {
    setCurrentImageIndex(index);
    setIsImageSliderOpen(true);
    setIsImageTransitioning(false); // Reset transition state
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  };

  const closeImageSlider = () => {
    setIsImageSliderOpen(false);
    setIsImageTransitioning(false); // Reset transition state
    document.body.style.overflow = 'unset'; // Restore scrolling
  };

  const nextImage = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isImageTransitioning) return;

    setIsImageTransitioning(true);
    setCurrentImageIndex((prev) => (prev + 1) % funActivities.length);
    setTimeout(() => setIsImageTransitioning(false), 300);
  };

  const prevImage = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isImageTransitioning) return;

    setIsImageTransitioning(true);
    setCurrentImageIndex((prev) =>
      prev === 0 ? funActivities.length - 1 : prev - 1
    );
    setTimeout(() => setIsImageTransitioning(false), 300);
  };

  const goToImage = (index, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isImageTransitioning || index === currentImageIndex) return;

    setIsImageTransitioning(true);
    setCurrentImageIndex(index);
    setTimeout(() => setIsImageTransitioning(false), 300);
  };

  // Enhanced keyboard event handler
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!isImageSliderOpen) return;

      switch (e.key) {
        case 'Escape':
          closeImageSlider();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          prevImage();
          break;
        case 'ArrowRight':
          e.preventDefault();
          nextImage();
          break;
        default:
          break;
      }
    };

    if (isImageSliderOpen) {
      document.addEventListener('keydown', handleKeyPress);
      return () => document.removeEventListener('keydown', handleKeyPress);
    }
  }, [isImageSliderOpen, currentImageIndex, isImageTransitioning]);

  const scroll = (direction) => {
    const container = scrollRef.current;
    const scrollAmount = 260; // Card width + gap

    if (direction === 'left') {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const handleScroll = () => {
    const container = scrollRef.current;
    setShowLeftArrow(container.scrollLeft > 0);
    setShowRightArrow(
      container.scrollLeft < container.scrollWidth - container.clientWidth
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-cyan-50 overflow-hidden">
      <Header />

      {/* Section 1: Vision & Mission - Light Theme */}
      <section id="vision-mission" className="relative z-10 px-6 py-20 bg-gradient-to-br from-blue-50 via-indigo-50 to-cyan-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-blue-200/100 rounded-full text-blue-700 text-sm font-medium mb-6 backdrop-blur-sm">
              {/* <Eye className="w-4 h-4 mr-2 text-blue-500" /> */}
              {/* Excellence today, better future tomorrow. */}
              {/* Shaping the future with excellence. */}
              Driving excellence, shaping tomorrow
            </div>
            <h2 className="text-4xl font-bold mb-4">
              <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                Vision & Mission
              </span>
            </h2>
            <p className="text-lg text-blue-700/80 max-w-2xl mx-auto">
              Driving the future of digital payments with innovation and excellence
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Vision */}
            <div className="group bg-white/70 backdrop-blur-sm rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-500 border border-blue-100/50 hover:border-blue-300/50 hover:-translate-y-2">
              <div className="flex items-center mb-6">
                <div className="w-14 h-14 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                  <Eye className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Our Vision</h3>
              </div>
              <p className="text-blue-700/80 text-lg leading-relaxed mb-6">
                To revolutionize the global payment ecosystem by creating seamless, secure, and intelligent financial solutions that empower businesses of all sizes to thrive in the digital economy.
              </p>
              <div className="space-y-3">
                <div className="flex items-center text-blue-600">
                  <CheckCircle className="w-5 h-5 mr-3 text-green-500" />
                  <span>Global payment accessibility</span>
                </div>
                <div className="flex items-center text-blue-600">
                  <CheckCircle className="w-5 h-5 mr-3 text-green-500" />
                  <span>Cutting-edge security standards</span>
                </div>
                <div className="flex items-center text-blue-600">
                  <CheckCircle className="w-5 h-5 mr-3 text-green-500" />
                  <span>Innovation-driven solutions</span>
                </div>
              </div>
            </div>

            {/* Mission */}
            <div className="group bg-white/70 backdrop-blur-sm rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-500 border border-blue-100/50 hover:border-blue-300/50 hover:-translate-y-2">
              <div className="flex items-center mb-6">
                <div className="w-14 h-14 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                  <Target className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Our Mission</h3>
              </div>
              <p className="text-blue-700/80 text-lg leading-relaxed mb-6">
                We are committed to delivering exceptional payment processing services through innovative technology, uncompromising security, and outstanding customer support that drives business growth and success.
              </p>
              <div className="space-y-3">
                <div className="flex items-center text-blue-600">
                  <Heart className="w-5 h-5 mr-3 text-red-500" />
                  <span>Customer-centric approach</span>
                </div>
                <div className="flex items-center text-blue-600">
                  <Heart className="w-5 h-5 mr-3 text-red-500" />
                  <span>Reliability and trust</span>
                </div>
                <div className="flex items-center text-blue-600">
                  <Heart className="w-5 h-5 mr-3 text-red-500" />
                  <span>Continuous improvement</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Features - Dark Theme */}
      <section id="features" className="relative z-10 px-6 py-20 bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            {/* <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-blue-200 text-sm font-medium mb-6">
              <Zap className="w-4 h-4 mr-2 text-blue-300" />
              Our Capabilities
            </div> */}
            <h2 className="text-5xl font-bold mb-4">
              <span className="bg-gradient-to-r from-blue-300 to-purple-100 bg-clip-text text-transparent">
                Our Differentiators
              </span>
            </h2>
            <p className="text-lg text-blue-200/80 max-w-2xl mx-auto">
              Built for modern businesses that demand speed, security, and seamless integration
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`group p-6 bg-white/5 backdrop-blur-sm rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 border border-white/10 hover:border-blue-300/50 hover:-translate-y-2 ${currentFeature === index ? '' : ''
                  }`}
              >
                <div className="w-12 h-12 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <div className="text-white">
                    {feature.icon}
                  </div>
                </div>
                <h3 className="font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-blue-200/70 text-sm">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* Section 4: Fun Activities - Dark Theme */}
      <section id="fun-activities" className="relative z-10 px-6 py-20 bg-gradient-to-br from-gray-900 via-purple-900 to-indigo-900">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-purple-200 text-sm font-medium mb-6">
              <Camera className="w-4 h-4 mr-2 text-purple-300" />
              Company Culture
            </div>
            <h2 className="text-3xl font-bold mb-3">
              <span className="bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text text-transparent">
                Fun Activities & Team Spirit
              </span>
            </h2>
            <p className="text-lg text-purple-200/80 max-w-2xl mx-auto">
              Building connections and celebrating achievements together
            </p>
          </div>

          <div className="relative">
            <div className="overflow-x-auto scrollbar-hide">
              <div className="flex space-x-6 pb-4" style={{ width: 'max-content' }}>
                {funActivities.map((activity, index) => (
                  <div
                    key={activity.id}
                    className="flex-shrink-0 w-80 bg-white/5 backdrop-blur-sm rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-white/10 hover:border-purple-300/50 hover:-translate-y-2 overflow-hidden"
                  >
                    <div className="relative h-48 overflow-hidden cursor-pointer group" onClick={() => openImageSlider(index)}>
                      <img
                        src={activity.image}
                        alt={activity.title}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                      <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                        <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 transform scale-75 group-hover:scale-100 transition-transform duration-300">
                          <ZoomIn className="w-6 h-6 text-purple-600" />
                        </div>
                      </div>

                      <div className="absolute top-3 left-3">
                        <div className="inline-flex items-center px-2 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-medium text-white">
                          {activity.icon}
                          <span className="ml-1">{activity.category}</span>
                        </div>
                      </div>
                    </div>

                    <div className="p-5">
                      <h3 className="text-lg font-bold text-white mb-2 leading-tight">
                        {activity.title}
                      </h3>
                      <p className="text-gray-300 text-sm leading-relaxed mb-4 line-clamp-2">
                        {activity.description}
                      </p>

                      <div className="space-y-2 mb-4">
                        {/* <div className="flex items-center text-purple-300 text-sm">
                          <Calendar className="w-4 h-4 mr-2 text-purple-400" />
                          <span>{activity.date}</span>
                        </div> */}
                        <div className="flex items-center text-purple-300 text-sm">
                          <MapPin className="w-4 h-4 mr-2 text-purple-400" />
                          <span className="truncate">{activity.location}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .scrollbar-hide {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
          .line-clamp-2 {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        `}</style>
      </section>

      {isImageSliderOpen && (
        <div className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 flex items-center justify-center">
          <button
            onClick={closeImageSlider}
            className="absolute top-6 right-6 z-[70] w-12 h-12 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:text-white transition-all duration-300 hover:scale-110"
          >
            <X className="w-6 h-6" />
          </button>

          <button
            onClick={prevImage}
            className="absolute left-6 top-1/2 transform -translate-y-1/2 z-[70] w-12 h-12 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:text-white transition-all duration-300 hover:scale-110"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>

          <button
            onClick={nextImage}
            className="absolute right-6 top-1/2 transform -translate-y-1/2 z-[70] w-12 h-12 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:text-white transition-all duration-300 hover:scale-110"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          <div className="relative w-full h-full flex items-center justify-center p-6 z-[51]">
            <div className="relative max-w-5xl max-h-full">
              <img
                src={funActivities[currentImageIndex]?.image}
                alt={funActivities[currentImageIndex]?.title}
                className={`max-w-full max-h-full object-contain rounded-lg shadow-2xl transition-all duration-300 ${isImageTransitioning ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
                  }`}
              />

              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg z-[52]">
                <div className="text-white">
                  <div className="flex items-center mb-2">
                    <div className="inline-flex items-center px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium mr-3">
                      {funActivities[currentImageIndex]?.icon}
                      <span className="ml-1">{funActivities[currentImageIndex]?.category}</span>
                    </div>
                    <span className="text-sm text-white/80">{currentImageIndex + 1} / {funActivities.length}</span>
                  </div>
                  <h3 className="text-2xl font-bold mb-2">{funActivities[currentImageIndex]?.title}</h3>
                  <p className="text-white/90 mb-3">{funActivities[currentImageIndex]?.description}</p>
                  <div className="flex items-center space-x-4 text-sm text-white/80">
                    <div className="flex items-center">
                      <Calendar className="w-4 h-4 mr-1" />
                      {funActivities[currentImageIndex]?.date}
                    </div>
                    <div className="flex items-center">
                      <MapPin className="w-4 h-4 mr-1" />
                      {funActivities[currentImageIndex]?.location}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-[65]">
            <div className="flex space-x-2 bg-black/50 backdrop-blur-sm rounded-full p-2">
              {funActivities.map((activity, index) => (
                <button
                  key={activity.id}
                  onClick={() => goToImage(index)}
                  className={`w-12 h-12 rounded-full overflow-hidden border-2 transition-all duration-300 ${index === currentImageIndex
                    ? 'border-white scale-110'
                    : 'border-white/50 hover:border-white/80 hover:scale-105'
                    }`}
                >
                  <img
                    src={activity.image}
                    alt={activity.title}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* Team Section */}
      {/* <section className="relative z-10 px-6 py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto">
         <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-blue-100/80 rounded-full text-blue-700 text-sm font-medium mb-6 backdrop-blur-sm">
            <Users className="w-4 h-4 mr-2 text-blue-500" />
            Our Leadership Team
          </div>
          <h2 className="text-4xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              Meet Our Excellent Team
            </span>
          </h2>
          <p className="text-lg text-blue-700/80 max-w-2xl mx-auto">
            Talented professionals dedicated to revolutionizing payment processing
          </p>
        </div>

         <div className="flex justify-center mb-16">
          <div className="group relative bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-500 border border-blue-200/50 hover:border-blue-300/50 hover:-translate-y-3 overflow-hidden max-w-md">
             <div className="absolute top-4 left-4 z-10 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold flex items-center shadow-lg">
              <Crown className="w-3 h-3 mr-1" />
             </div>
            
             <div className="relative overflow-hidden rounded-t-3xl" style={{ height: '600px'}}>
              <img
                src={teamData.leader.Photo}
                alt={teamData.leader.OfficerName}
              style={{  objectFit: 'cover',objectPosition: '50% 50%' }}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
               <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-3 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0">
                <a 
                  href={`mailto:${teamData.leader.Email}`}
                  className="w-12 h-12 bg-white/90 hover:bg-blue-500 text-blue-600 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-lg"
                >
                  <Mail className="w-5 h-5" />
                </a>
                <div className="relative group/share">
                  <button className="w-12 h-12 bg-white/90 hover:bg-indigo-500 text-indigo-600 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-lg">
                    <Share2 className="w-5 h-5" />
                  </button>
                  <div className="absolute bottom-14 left-1/2 transform -translate-x-1/2 flex space-x-2 opacity-0 group-hover/share:opacity-100 transition-all duration-300 pointer-events-none group-hover/share:pointer-events-auto">
                    <a href="#" className="w-10 h-10 bg-blue-500 hover:bg-blue-600 text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-lg">
                      <Twitter className="w-4 h-4" />
                    </a>
                    <a href="#" className="w-10 h-10 bg-blue-600 hover:bg-blue-700 text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-lg">
                      <Facebook className="w-4 h-4" />
                    </a>
                    <a href="#" className="w-10 h-10 bg-pink-500 hover:bg-pink-600 text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-lg">
                      <Instagram className="w-4 h-4" />
                    </a>
                  </div>
                </div>
                <a 
                  href={`tel:${teamData.leader.Mobile}`}
                  className="w-12 h-12 bg-white/90 hover:bg-green-500 text-green-600 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-lg"
                >
                  <Phone className="w-5 h-5" />
                </a>
              </div>
            </div>
            
             <div className="p-8 text-center">
              <h3 className="font-bold text-gray-800 text-2xl mb-2 group-hover:text-blue-600 transition-colors duration-300">
                {teamData.leader.OfficerName}
              </h3>
              <p className="text-blue-600 font-medium mb-4 text-sm uppercase tracking-wider">
                {teamData.leader.OfficerDesignation}
              </p>
              
               {teamData.leader.Bio && (
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {teamData.leader.Bio}
                </p>
              )}
              
               <div className="space-y-2 text-sm text-gray-600">
                <div className="flex items-center justify-center hover:text-blue-600 transition-colors">
                  <Mail className="w-4 h-4 mr-2 text-blue-500" />
                  <span className="truncate">{teamData.leader.Email}</span>
                </div>
                <div className="flex items-center justify-center hover:text-blue-600 transition-colors">
                  <Phone className="w-4 h-4 mr-2 text-blue-500" />
                  <span>{teamData.leader.Mobile}</span>
                </div>
              </div>
            </div>
            
             <div className="absolute top-16 right-4 w-4 h-4 bg-blue-400 rounded-full animate-pulse opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div className="absolute top-20 right-8 w-3 h-3 bg-indigo-400 rounded-full animate-pulse opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
          </div>
        </div>

         <div className="mb-8">
         
          <div className="relative">
             {showLeftArrow && (
              <button
                onClick={() => scroll('left')}
                className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/90 hover:bg-white shadow-lg rounded-full flex items-center justify-center text-blue-600 hover:text-blue-700 transition-all duration-300 hover:scale-110"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
            )}

             {showRightArrow && (
              <button
                onClick={() => scroll('right')}
                className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/90 hover:bg-white shadow-lg rounded-full flex items-center justify-center text-blue-600 hover:text-blue-700 transition-all duration-300 hover:scale-110"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            )}

             <div
              ref={scrollRef}
              onScroll={handleScroll}
              className="flex gap-4 overflow-x-auto scrollbar-hide py-4 px-12"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              {teamData.employees.map((employee, index) => (
                <div
                  key={employee.Id || index}
                  className="group relative bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 border border-blue-100/50 hover:border-blue-300/50 hover:-translate-y-2 overflow-hidden flex-shrink-0"
                  style={{ minWidth: '240px', maxWidth: '240px' }}
                >
                   <div className="relative overflow-hidden rounded-t-2xl" style={{ height: '180px' }}>
                    <img
                      src={employee.Photo}
                      alt={employee.OfficerName}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    
                     <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 flex space-x-2 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0">
                      <a 
                        href={`mailto:${employee.Email}`}
                        className="w-7 h-7 bg-white/90 hover:bg-blue-500 text-blue-600 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-lg"
                      >
                        <Mail className="w-3 h-3" />
                      </a>
                      <a 
                        href={`tel:${employee.Mobile}`}
                        className="w-7 h-7 bg-white/90 hover:bg-green-500 text-green-600 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-lg"
                      >
                        <Phone className="w-3 h-3" />
                      </a>
                    </div>
                  </div>
                  
                   <div className="p-4 text-center">
                    <h3 className="font-bold text-gray-800 text-lg mb-1 group-hover:text-blue-600 transition-colors duration-300">
                      {employee.OfficerName}
                    </h3>
                    <p className="text-blue-600 font-medium mb-3 text-xs uppercase tracking-wider">
                      {employee.OfficerDesignation}
                    </p>
                    
                     <div className="space-y-1 text-xs text-gray-600">
                      <div className="flex items-center justify-center hover:text-blue-600 transition-colors">
                        <Mail className="w-3 h-3 mr-1 text-blue-500" />
                        <span className="truncate max-w-36">{employee.Email}</span>
                      </div>
                      <div className="flex items-center justify-center hover:text-blue-600 transition-colors">
                        <Phone className="w-3 h-3 mr-1 text-blue-500" />
                        <span>{employee.Mobile}</span>
                      </div>
                    </div>
                  </div>
                  
                   <div className="absolute top-3 right-3 w-2 h-2 bg-blue-400 rounded-full animate-pulse opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section> */}
      {/* Stats Section */}

      <CompanyLogosMarquee />


      {/* CTA Section */}
      <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

          <div className="absolute top-1/4 left-1/4 animate-float">
            <Zap className="w-8 h-8 text-white/20" />
          </div>
          <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Shield className="w-6 h-6 text-white/20" />
          </div>
          <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
            <TrendingUp className="w-7 h-7 text-white/20" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* Main Content */}
          <div className="space-y-4 animate-fadeInUp">
            <h2 className="text-2xl sm:text-4xl lg:text-4xl font-bold text-white leading-tight animate-slideInLeft">
              Ready to Transform Your Business?
            </h2>
            <p className="text-1xl sm:text-1xl lg:text-1xl text-blue-100">Get started with our comprehensive suite of business solutions today</p>
          </div>

          {/* CTA Button - Smaller and More Compact */}
          <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
            <button
              className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
              onClick={() => {
                window.location.href = '/contact';
              }}
            >
              {/* <Play className="w-5 h-5 group-hover:animate-bounce" /> */}
              <span>Get Started</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

              {/* Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
          </div>
        </div>

        <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(5deg); }
          66% { transform: translateY(5px) rotate(-5deg); }
        }
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInLeft {
          animation: slideInLeft 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInRight {
          animation: slideInRight 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInUp {
          animation: slideInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
      </section>

      {/* Client Logo Slider full width */}
      <div className="mb-5 mt-10 px-4 sm:px-6 lg:px-8">
        <div className="space-y-6 animate-fadeInUp">
          <h2 className="text-2xl sm:text-3xl lg:text-3xl xl:text-4xl font-bold text-center leading-tight transform transition-all duration-700 animate-slideInLeft">
            <span className="text-indigo-500">Our </span>
            <span className="text-pink-500">Clients</span>
          </h2>
          {/* <p className="text-lg sm:text-xl lg:text-2xl text-gray-600 text-center max-w-2xl mx-auto">
      We’re proud to have partnered with incredible businesses, bringing innovation and excellence together.
    </p> */}
        </div>
      </div>

      <div className="relative w-full">
        {/* White strip stays same height */}
        <div className="absolute top-1/2 left-0 w-full h-40 bg-white -translate-y-1/2"></div>

        {/* Sliding logos */}
        <div className="overflow-hidden relative w-full">
          <div className="flex gap-6 sm:gap-8 lg:gap-12 slide-track">
            {/* Repeat logos */}
            {[
              "WL.png",
              "onePay.png",
              "gramePay.png",
              "vc2.png",
              "avenSprint.png",
              "blueStar.png",
              "delloite.png",
              "serum.png",
              "saintGobain.png",
              "mumbaiPolice.png",
              "rtCom.png",
              "x-Biz.png",
              "aimil.png",
            ].map((logo, idx) => (
              <div
                key={idx}
                className="flex items-center justify-center w-36 sm:w-48 lg:w-56 h-36 flex-shrink-0"
              >
                <img
                  src={logo}
                  alt={`Client ${idx + 1}`}
                  className="max-h-32 max-w-full object-contain"
                />
              </div>
            ))}

            {/* Duplicate set for seamless loop */}
            {[
              "WL.png",
              "onePay.png",
              "gramePay.png",
              "vc2.png",
              "avenSprint.png",
              "blueStar.png",
              "delloite.png",
              "serum.png",
              "saintGobain.png",
              "mumbaiPolice.png",
              "rtCom.png",
              "x-Biz.png",
              "aimil.png",
            ].map((logo, idx) => (
              <div
                key={`dup-${idx}`}
                className="flex items-center justify-center w-36 sm:w-48 lg:w-56 h-36 flex-shrink-0"
              >
                <img
                  src={logo}
                  alt={`Client ${idx + 1}`}
                  className="max-h-32 max-w-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Inline CSS */}
      <style>{`
  @keyframes slide {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  .slide-track {
    animation: slide 30s linear infinite;
    width: max-content;
  }

  @media (max-width: 768px) {
    .slide-track {
      animation-duration: 20s;
    }

    h2 {
      font-size: 1.55rem; /* Adjusting header font size for smaller screens */
    }
  }

  @media (max-width: 480px) {
    .slide-track {
      animation-duration: 15s;
    }

    h2 {
      font-size: 1.5rem; /* Further adjusting for mobile */
    }
  }
`}</style>



      {/* Footer */}
      <Footer />
    </div>

  );
}
export default Aboutus;

